import React, { FC, useRef } from "react";
import type { HomeWhyPayallProps } from "@/types";
import { ContentManager } from "../content-manager";
import { Image } from "../image";
import { useInView } from "@/hooks/reveal-in-view";

export const HomeWhyPayall: FC<HomeWhyPayallProps> = ({
  cards,
  whyPayAllText,
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });
  return (
    <section className="homeWhyPayall">
      <div className="homeWhyPayall--inner">
        <div className="wrapper wrapper_lg">
          <div className="homeWhyPayall--content">
            <div className="homeWhyPayall--cards" ref={ref}>
              {cards.map((card, index) => {
                return (
                  <div
                    key={index}
                    className="homeWhyPayall--card"
                    style={{
                      transform: isInView
                        ? "none"
                        : `translateY(${20 * (index + 1)}px)`,
                      opacity: isInView ? 1 : 0,
                      transition:
                        "all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)",
                    }}
                    onMouseEnter={(event) => {
                      const target = event.currentTarget as HTMLElement;
                      target.classList.add("hover-animation-bounce");
                    }}
                    onAnimationEnd={(event) => {
                      const target = event.target as HTMLElement;
                      target.classList.remove("hover-animation-bounce");
                    }}
                  >
                    <div className="homeWhyPayall--card-label">
                      {whyPayAllText}
                    </div>
                    {card.image?.file?.url && (
                      <Image
                        className="homeWhyPayall--card-icon"
                        src={card.image as any}
                        alt={card.image.title}
                        options={{
                          sizes: {
                            exec: [
                              {
                                width: 241,
                                height: 36,
                              },
                            ],
                          },
                        }}
                        style={{
                          transform: isInView
                            ? "none"
                            : `translateY(${40 * (index + 1)}px)`,
                          opacity: isInView ? 1 : 0,
                          transition: "all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)",
                        }}
                      />
                    )}
                    {card.title && (
                      <ContentManager
                        content={card.title}
                        className="homeWhyPayall--card-title"
                        style={{
                          transform: isInView
                            ? "none"
                            : `translateY(${50 * (index + 1)}px)`,
                          opacity: isInView ? 1 : 0,
                          transition: "all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)",
                        }}
                      />
                    )}
                    {card.description && (
                      <ContentManager
                        content={card.description}
                        className="homeWhyPayall--card-description"
                        style={{
                          transform: isInView
                            ? "none"
                            : `translateY(${60 * (index + 1)}px)`,
                          opacity: isInView ? 1 : 0,
                          transition: "all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)",
                        }}
                      />
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
